import { BrowserRouter } from "react-router-dom";
import './assets/css/soft-ui-dashboard.css';
import './assets/css/nucleo-icons.css';
import './App.scss';
import Body from './components/Body';
import InputProvider from "./contexts/InputContext";

function App() {
  return (
    <>
      <InputProvider>
        <BrowserRouter basename={`${process.env.PUBLIC_URL}`}>
          <Body />
        </BrowserRouter>
      </InputProvider>
    </>
  );
}

export default App;
